var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllAssets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1403 14.8319C24.14 14.6078 24.0809 14.3878 23.9687 14.1938C23.8566 13.9998 23.6954 13.8387 23.5014 13.7267L19.0293 11.1712C18.8351 11.059 18.6147 11 18.3904 11C18.1662 11 17.9458 11.059 17.7516 11.1712L13.2795 13.7267C13.0854 13.8387 12.9243 13.9998 12.8121 14.1938C12.7 14.3878 12.6409 14.6078 12.6406 14.8319V19.9428C12.6409 20.1669 12.7 20.387 12.8121 20.581C12.9243 20.775 13.0854 20.9361 13.2795 21.0481L17.7516 23.6036C17.9458 23.7157 18.1662 23.7747 18.3904 23.7747C18.6147 23.7747 18.8351 23.7157 19.0293 23.6036L23.5014 21.0481C23.6954 20.9361 23.8566 20.775 23.9687 20.581C24.0809 20.387 24.14 20.1669 24.1403 19.9428V14.8319Z",
    stroke: "#686978",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.832 14.1934L18.3902 17.3877M18.3902 17.3877L23.9483 14.1934M18.3902 17.3877V23.7764",
    stroke: "#686978",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 15.0526C12.4994 14.8285 12.4403 14.6085 12.3281 14.4145C12.216 14.2205 12.0548 14.0594 11.8608 13.9474L7.38868 11.3919C7.19444 11.2797 6.9741 11.2207 6.74981 11.2207C6.52553 11.2207 6.30519 11.2797 6.11095 11.3919L1.63887 13.9474C1.44482 14.0594 1.28364 14.2205 1.17151 14.4145C1.05938 14.6085 1.00023 14.8285 1 15.0526V20.1635C1.00023 20.3876 1.05938 20.6077 1.17151 20.8017C1.28364 20.9957 1.44482 21.1568 1.63887 21.2688L6.11095 23.8243C6.30519 23.9364 6.52553 23.9954 6.74981 23.9954C6.9741 23.9954 7.19444 23.9364 7.38868 23.8243L11.8608 21.2688C12.0548 21.1568 12.216 20.9957 12.3281 20.8017C12.4403 20.6077 12.4994 20.3876 12.4996 20.1635V15.0526Z",
    stroke: "#686978",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19141 14.4141L6.74956 17.6084M6.74956 17.6084L12.3077 14.4141M6.74956 17.6084V23.9971",
    stroke: "#686978",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1403 4.8319C18.14 4.60783 18.0809 4.38776 17.9687 4.19377C17.8566 3.99978 17.6954 3.83869 17.5014 3.72666L13.0293 1.17118C12.8351 1.05904 12.6147 1 12.3904 1C12.1662 1 11.9458 1.05904 11.7516 1.17118L7.27949 3.72666C7.08545 3.83869 6.92427 3.99978 6.81214 4.19377C6.7 4.38776 6.64085 4.60783 6.64062 4.8319V9.94285C6.64085 10.1669 6.7 10.387 6.81214 10.581C6.92427 10.775 7.08545 10.9361 7.27949 11.0481L11.7516 13.6036C11.9458 13.7157 12.1662 13.7747 12.3904 13.7747C12.6147 13.7747 12.8351 13.7157 13.0293 13.6036L17.5014 11.0481C17.6954 10.9361 17.8566 10.775 17.9687 10.581C18.0809 10.387 18.14 10.1669 18.1403 9.94285V4.8319Z",
    stroke: "#686978",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 4.19336L12.3902 7.3877M12.3902 7.3877L17.9483 4.19336M12.3902 7.3877V13.7764",
    stroke: "#686978",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAssets);
export default __webpack_public_path__ + "static/media/allAssets.a6a29f11b7fff5637cf02f76c1e54fa5.svg";
export { ForwardRef as ReactComponent };